<p-toast />

<section class="w-full p-3">
  <app-content-card title="Super panel">
    <div class="flex flex-column md:flex-row md:align-items-center md:justify-content-between gap-3 mb-3">
      <p class="m-0 text-sm text-color-secondary">Iglesias registradas en la plataforma.</p>
      <p-button type="button" label="Registrar iglesia" icon="pi pi-plus" (onClick)="abrirRegistro()" />
    </div>

    @if (loadError()) {
      <p class="m-0 text-sm text-red-500">No se pudo cargar el listado.</p>
    } @else {
      <div class="overflow-x-auto">
        <p-table
          [value]="iglesias()"
          [loading]="loading()"
          [showLoader]="iglesias().length > 0"
          dataKey="id"
          size="small"
          [rowHover]="true"
          styleClass="p-datatable-sm w-full"
          [tableStyle]="{ 'min-width': '48rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Iglesia</th>
              <th>Pastor</th>
              <th>Celular</th>
              <th>Ciudad</th>
              <th>Estado</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-iglesia>
            <tr>
              <td>{{ iglesia.nombreIglesia }}</td>
              <td>{{ iglesia.nombrePastor || '—' }}</td>
              <td>{{ iglesia.celular || '—' }}</td>
              <td>{{ iglesia.ciudad || '—' }}</td>
              <td>{{ activa(iglesia) ? 'Activa' : 'Inactiva' }}</td>
              <td class="text-right white-space-nowrap">
                <p-button
                  type="button"
                  [label]="viendo(iglesia.nombreIglesia) ? 'Salir' : 'Entrar'"
                  [icon]="viendo(iglesia.nombreIglesia) ? 'pi pi-sign-out' : 'pi pi-sign-in'"
                  [outlined]="!viendo(iglesia.nombreIglesia)"
                  size="small"
                  styleClass="mr-2"
                  [loading]="cambiando() === iglesia.nombreIglesia"
                  [disabled]="cambiando() !== null && cambiando() !== iglesia.nombreIglesia"
                  (onClick)="viendo(iglesia.nombreIglesia) ? salir() : entrar(iglesia.nombreIglesia)"
                />
                <p-button
                  type="button"
                  label="Gráficos"
                  icon="pi pi-chart-bar"
                  [outlined]="true"
                  size="small"
                  (onClick)="verGraficos(iglesia.nombreIglesia)"
                />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="loadingbody">
            @if (iglesias().length === 0) {
              @for (item of skeletonRows; track item) {
                <tr>
                  @for (col of [0, 1, 2, 3, 4, 5]; track col) {
                    <td class="py-2"><p-skeleton height="1rem" /></td>
                  }
                </tr>
              }
            }
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center p-3 text-color-secondary">
                Todavía no hay iglesias registradas.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </app-content-card>

  <app-content-card title="Contactos" class="mt-3 block">
    <p class="m-0 mb-3 text-sm text-color-secondary">
      Pedidos de quien quiere que lo contacten desde la página de inicio.
    </p>

    @if (contactosError()) {
      <p class="m-0 text-sm text-red-500">No se pudo cargar los contactos.</p>
    } @else {
      <div class="overflow-x-auto">
        <p-table
          [value]="contactos()"
          [loading]="contactosLoading()"
          [showLoader]="contactos().length > 0"
          [paginator]="contactos().length > 10"
          [rows]="10"
          dataKey="id"
          size="small"
          [rowHover]="true"
          styleClass="p-datatable-sm w-full"
          [tableStyle]="{ 'min-width': '72rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Fecha</th>
              <th>Nombre</th>
              <th>Iglesia</th>
              <th>Celular</th>
              <th>País</th>
              <th>Provincia</th>
              <th>Horario</th>
              <th>Nota</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-contacto>
            <tr>
              <td class="white-space-nowrap">
                {{ contacto.creado ? (contacto.creado | date: 'dd/MM/yyyy HH:mm') : '—' }}
              </td>
              <td>{{ contacto.nombre || '—' }}</td>
              <td>{{ contacto.iglesia || '—' }}</td>
              <td class="white-space-nowrap">{{ contacto.celular }}</td>
              <td>{{ contacto.pais }}</td>
              <td>{{ contacto.provincia }}</td>
              <td class="white-space-nowrap">{{ contacto.horario }}</td>
              <td style="max-width: 22rem; white-space: normal">{{ contacto.nota || '—' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="loadingbody">
            @if (contactos().length === 0) {
              @for (item of skeletonRows; track item) {
                <tr>
                  @for (col of [0, 1, 2, 3, 4, 5, 6, 7]; track col) {
                    <td class="py-2"><p-skeleton height="1rem" /></td>
                  }
                </tr>
              }
            }
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" class="text-center p-3 text-color-secondary">
                Todavía no hay pedidos de contacto.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </app-content-card>
</section>

<p-dialog
  header="Registrar iglesia"
  [visible]="dialogoAbierto()"
  (visibleChange)="dialogoAbierto.set($event)"
  [modal]="true"
  [draggable]="false"
  [closable]="!guardando()"
  [dismissableMask]="!guardando()"
  [style]="{ width: '32rem' }"
>
  <form class="flex flex-column gap-3" [formGroup]="form" (ngSubmit)="registrar()">
    <div class="flex flex-column gap-1">
      <label class="text-sm font-medium" for="super-iglesia">Nombre de la iglesia</label>
      <input pInputText id="super-iglesia" formControlName="nombreIglesia" autocomplete="off" />
    </div>
    <div class="flex flex-column md:flex-row gap-3">
      <div class="flex flex-column gap-1 flex-1">
        <label class="text-sm font-medium" for="super-pastor">Pastor</label>
        <input pInputText id="super-pastor" formControlName="nombrePastor" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-1 flex-1">
        <label class="text-sm font-medium" for="super-celular">Celular</label>
        <input pInputText id="super-celular" formControlName="celular" autocomplete="off" inputmode="tel" />
      </div>
    </div>
    <div class="flex flex-column gap-1">
      <label class="text-sm font-medium" for="super-direccion">Dirección</label>
      <input pInputText id="super-direccion" formControlName="direccion" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-1">
      <label class="text-sm font-medium" for="super-ciudad">Ciudad</label>
      <input pInputText id="super-ciudad" formControlName="ciudad" autocomplete="off" />
    </div>

    <p class="m-0 text-sm text-color-secondary">
      Se crea un administrador con datos genéricos para que después des de alta al admin real.
      @if (mailAdmin()) {
        Entra con <span class="font-medium text-color">{{ mailAdmin() }}</span> y la contraseña en blanco.
      }
    </p>

    <div class="flex justify-content-end gap-2 pt-2">
      <p-button
        type="button"
        label="Cancelar"
        severity="secondary"
        [outlined]="true"
        [disabled]="guardando()"
        (onClick)="cerrarRegistro()"
      />
      <p-button type="submit" label="Registrar" icon="pi pi-check" [loading]="guardando()" />
    </div>
  </form>
</p-dialog>
